import React from 'react';
import {connect} from "react-redux";
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "material-ui";
import {closeDeleteRegulationFetch, deleteRegulation} from "../../../redux/actions/regulations";
import {snackMessageShow} from "../../../redux/actions/snack_message";

export class RegulationDeleteDialog extends React.Component {

    onClickSubmit = () => {
        this.props.deleteRegulation(this.props.regulation, () => {
            this.props.handleClose();
        });
    };

    render() {

        const {open, handleClose} = this.props;

        return (
            <Dialog
                open={open}>

                <DialogTitle>
                    法令チェック項目の削除
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        選択した法令チェック項目を削除します。<br/>
                        この操作で削除されたデータは、復旧することができません。<br/>
                        また、この法令に関する全ての情報が削除されます。
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="default">
                        キャンセル
                    </Button>
                    <Button onClick={this.onClickSubmit.bind(this)} color="primary" autoFocus>
                        削除する
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

RegulationDeleteDialog = connect(
    (state) => {
        return {
            regulation: state.regulations.regulation,
        }
    },
    (dispatch) => {
        return {
            deleteRegulation: (regulation, callback) => {
                dispatch(deleteRegulation(regulation)).then((response) => {
                    setTimeout(() => {
                        dispatch(closeDeleteRegulationFetch());
                        switch (response.type) {
                            case 'API_DELETE_REGULATION_FAIL':
                                dispatch(snackMessageShow('法令の削除に失敗しました'));
                                break;
                            default:
                                dispatch(snackMessageShow('法令を削除しました'));
                                callback();
                        }
                    }, 200);
                });
            },
        }
    }
)(RegulationDeleteDialog);


// WEBPACK FOOTER //
// ./src/containers/regulation/dialog/delete.js